import { useCallback, useMemo, useState, FocusEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { weblinkValidationScheme } from '~/Helpers/Validators.helper';
import { useDebouncedSearch, useNavigation } from '~/Hooks';
import { requestUpdateEvent, selectEventById } from '~/store/events';

export const useLivestreamUpdate = () => {
  // hooks
  const { getParams } = useNavigation();
  const { id } = getParams();
  const dispatch = useDispatch();

  // selectors
  const selectedEvent = useSelector(selectEventById(id || ''));

  // actions
  const updateEvent = bindActionCreators(requestUpdateEvent, dispatch);

  const [shouldShowLink, setShowLink] = useState(true);
  const setShouldShowLink = useCallback(
    ({ type }: FocusEvent<HTMLInputElement>) => setShowLink(type === 'blur'),
    [setShowLink],
  );
  const virtualClassUrl = useMemo(() => selectedEvent?.virtualClassUrl?.trim() || '', [
    selectedEvent,
  ]);
  const { setInputText: setLivestreamLink, inputText: livestreamLink } = useDebouncedSearch(
    (link: string) =>
      weblinkValidationScheme({ exact: true, strict: true }).test(link) &&
      updateEvent({
        ...selectedEvent,
        virtualClassUrl: link,
      }),
    virtualClassUrl,
  );
  const isLivestreamLinkValid = useMemo(
    () => weblinkValidationScheme({ exact: true, strict: true }).test(livestreamLink),
    [livestreamLink],
  );

  return {
    livestreamLink,
    setLivestreamLink,
    shouldShowLink,
    setShouldShowLink,
    isLivestreamLinkValid,
  };
};
